// types
import { i18nDispatcherCodebooks } from 'models/i18n';

// ==============================|| I18N SK CODEBOOKS ||============================== //

const skDispatcherCodebooks: i18nDispatcherCodebooks = {
  LOSS_OF_POWER_SUPPLY_VOLTAGE: { title: 'Strata napájacieho napätia' },
  BATTERY_COMMUNICATION_MALFUNCTION: {
    title: 'Porucha komunikácie batériového úložiska'
  },
  BATTERY_CHARGING_FAILURE: { title: 'Porucha dobíjania batérie' },
  BATTERY_MALFUNCTION: { title: 'Porucha batérie' },
  LOSS_OF_SIGNAL_AND_CONTROL_VOLTAGE: {
    title: 'Strata signalizačného a ovládacieho napätia'
  },
  OOM_METER_COMMUNICATION_FAILURE: {
    title: 'Porucha komunikácie s elektromerom na prahu OOM'
  },
  DEVICE_METER_COMMUNICATION_FAILURE: {
    title:
      'Porucha komunikácie s elektromerom svorkového merania zdroja/zariadenia'
  },
  LOCAL_DELIVERY_POINT_CONTROL: { title: 'Miestne ovládanie OOM' },
  HRM_BLOCKED_BY_DISTRIBUTOR: {
    title: 'HRM blokovaný z dispečingu distribučnej spoločnosti'
  },
  PROTECTOR_FAILURE: { title: 'Porucha ochrany' },
  PROTECTOR_ACTION: { title: 'Pôsobenie ochrany' },
  FUSE_BLOWN: { title: 'Prepálená poistka' },
  DEVICE_FAILURE: { title: 'Porucha zariadenia' },
  0: { title: 'Medzipoloha' },
  1: { title: 'Vypnutý' },
  2: { title: 'Zapnutý' },
  3: { title: 'Porucha' },
  ONLINE: { title: 'Online' },
  OFFLINE: { title: 'Offline' },
  AIEMS_OPERATION: { title: 'Ovládanie z AIEMS' },
  LOCAL_OPERATION: { title: 'Miestne ovládanie' },
  UNKNOWN: { title: 'Neznámy' },
  P_MODE: { title: 'Výkonová regulácia' },
  Q_MODE: { title: 'Prietoková regulácia' },
  WATER_LEVEL_MODE: { title: 'Hladinová regulácia' }
};

export default skDispatcherCodebooks;
